<div class="container customer-account">
  <!-- <div class="row"> -->
  <!-- <div class="col-md-2">
      <f-data-card>
        <p>Nav Placeholder</p>
      </f-data-card>
    </div> -->
  <div class="col-md-12 interaction-history-list">
    <div class="row">
      <div class="col-md-12 col-xl-7 interaction-history-list">
        <div class="header-IH">
          <h3 class="heading">Interaction History</h3>
          <div class="filter flex" *ngIf="showFilter()">
            <button mat-button color="primary" class="btn-filter" title="Filters" (click)="openFilter()">
              <span
                *ngIf="!intHistService.IHListViewDataCAMap[rootScopeService.activeCustTab.customerSessionId]?.isFilterApplied">
                <i class="fa-light fa-filter"></i>
              </span>
              <span
                *ngIf="intHistService.IHListViewDataCAMap[rootScopeService.activeCustTab.customerSessionId]?.isFilterApplied">
                <i class="fa-solid fa-filter"></i>
              </span>

              <span>Filters</span>
            </button>
            <button mat-button color="primary"
              disabled="{{!intHistService.IHListViewDataCAMap[rootScopeService.activeCustTab.customerSessionId]?.isFilterApplied}}"
              title="Clear Filter" class="clear-filter" (click)="clearFilter()">
              <span>Clear Filter</span>
            </button>
            <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
              <i class="fa-solid fa-arrows-rotate"></i>
            </button>
          </div>
        </div>
        <section class="error-wrapper" *ngIf="apiFailed == true">
          <f-alert variant="error">
            <p>
              {{ apiFailureMsg }}
            </p>
          </f-alert>

        </section>

        <!--Alert for Repeat Contact /Story CCR1-2514 -->
        <section class="error-wrapper" *ngIf="rootScopeService.activeCustTab.showRepeatAlertListView">
          <section class="error-wrapper">
            <f-alert variant="warning" is-dismissable="true" (dismiss)="closeWarning()">
              <p>
                <strong>{{ rootScopeService.getMsgPart1() }}:</strong> {{ rootScopeService.getMsgPart2()}}
              </p>
            </f-alert>
          </section>
        </section>
        <!--End of Alert for Repeat Contact /Story CCR1-2514 -->

        <app-alight-table *ngIf="intHistService.showAlightTableComponent"
          [dataSource]="intHistService.interHistListViewTableData" [totalRecords]="totalRecords"
          (rowSelection)="onRowSelection($event)" [gridColumns]="intHistService.listViewColumns"
          [rowPerPage]="rootScopeService.rowPerPage" [isShowButtons]="false" [isPagination]="true"
          [tableName]="'IHListView'" [selectedRow]="selectedRow"></app-alight-table>


        <app-tree-table *ngIf="!intHistService.showAlightTableComponent" [rowPerPage]="rootScopeService.rowPerPage"
          (rowSelection)="onRowSelection($event)" [selectedRow]="selectedRow"></app-tree-table>


        <app-loader *ngIf="IHListViewLoader" [loaderType]="rootScopeService.loaderTypeCard"
          [loaderMsg]="showLoaderMsg"></app-loader>
        <!-- amarjeet added-->
        <div class="footer-controls manage-alignment"
          *ngIf="intHistService.showAlightTableComponent && getTotalRecords() > 0">
          <div class="footer-controls-left ">
            <p class="display-result">
              Displaying <strong>{{ alightTable?.totalCount }}</strong> records
            </p>
          </div>
        </div>
        <div class="footer-controls manage-alignment"
          *ngIf="(!intHistService.showAlightTableComponent ) &&  getTotalRecords() > 0">
          <div class="footer-controls-left ">
            <p class="display-result">
              Displaying <strong>{{ alightTreeTable?.totalCount }}</strong> records
            </p>
          </div>
        </div>
        <!-- amarjeet added-->
        <!-- <h3 class="display-result" *ngIf="totalRecords > 0 && totalRecords <= 50">
            Currently displaying
            <strong>{{ alightTable.totalCount }}</strong> results
          </h3> -->
        <!-- <div class="footer-controls hide">
          <div class="footer-controls-left">
            <p class="display-result">
              Currently displaying <strong>20 of 150</strong> results
            </p>
          </div>

          <div class="footer-controls-right">
            <div class="custom-pagination hide1">
              <button class="arrow-btn" disabled mat-stroked-button title="Start Page">
                <i class="fa-solid fa-chevrons-left"></i>
              </button>
              <button class="arrow-btn" mat-stroked-button title="Previous">
                <i class="fa-solid fa-chevron-left"></i>
              </button>

              <button class="number selected" mat-stroked-button>1</button>
              <button class="number" mat-stroked-button>2</button>
              <button class="number" mat-stroked-button>3</button>
              <button class="number" mat-stroked-button>4</button>
              <button class="number" mat-stroked-button>15</button>

              <button class="arrow-btn" mat-stroked-button title="Next">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
              <button class="arrow-btn" mat-stroked-button title="Last Page">
                <i class="fa-solid fa-chevrons-right"></i>
              </button>
            </div>
          </div>
        </div> -->
      </div>
      <!-- Interaction Details section -->
      <div class="col-md-12 col-xl-5 form ih-detail-card">
        <app-interaction-history-detail-view [totalRecords]="getTotalRecords()"
          [selectedIHData]="selectedRowDetailView"></app-interaction-history-detail-view>
      </div>
      <!-- End of Interaction Details section -->
      <!-- Interaction Details section for additional accounts -->
      <div class="col-md-12 col-xl-5 form ih-detail-card hide">
        <f-data-card class="ih-card-container">
          <div class="flex justify-space-between">
            <h3 class="heading">
              Interaction Details
            </h3>
          </div>
          <div class="do-not-discuss hide">
            <p><i class="fa-sharp fa-solid fa-circle-exclamation"></i> Do not discuss: Opened by another account.</p>
          </div>

          <div class="no-result" *ngIf="totalRecords==0">
            <p>Select an interaction to see details.</p>
          </div>
          <div class="container" *ngIf="totalRecords!=0">
            <div class="row">
              <div class="col-md-12">
                <span class="form-label"> Topic </span>
                <span class="form-value">
                  Lorem Ipsum Lorem IpsumLorem IpsumLorem IpsumLorem Ipsum.
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Conversation ID </span>
                <span class="form-value"> N/A </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Source System </span>
                <span class="form-value"> ALIS </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Contact Type </span>
                <span class="form-value"> Lorem Ipsum </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Account Opened </span>
                <span class="form-value"> McDermot, Patrick </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Reason </span>
                <span class="form-value"> Authorized user </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Role</span>
                <span class="form-value"> HR/Manager </span>
              </div>
            </div>
            <div class="section-divider"></div>
            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Channel </span>
                <span class="form-value"> Call </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Date </span>
                <span class="form-value"> 8/5/2023 </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Domain </span>
                <span class="form-value"> Health </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Start Time </span>
                <span class="form-value"> 1:25 a.m. </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> End Time </span>
                <span class="form-value"> 1:25 a.m. </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Duration </span>
                <span class="form-value"> 2:14 </span>
              </div>
            </div>

            <div class="section-divider"></div>
            <div class="row">
              <div class="col-md-4">
                <span class="form-label"> Call Recording </span>
                <span class="form-value"> URL-123-Call-8/5/2022 </span>
              </div>
              <div class="col-md-4">
                <span class="form-label"> Chat Transcript </span>
                <span class="form-value"> N/A </span>
              </div>
            </div>
          </div>
        </f-data-card>
      </div>
      <!-- End of Interaction Details section for additional accounts -->

    </div>
  </div>
  <!-- </div> -->
</div>